var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { createContext, useEffect, useState } from 'react';
import Loader from 'shared-assets/components/Loader';
import ChartNavBar from 'shared-assets/facesheet-ui/components/ChartNavBar/ChartNavBar';
import { Button, Typography, Alert, Box } from '@kareo/design-system';
import rollbar from 'shared-assets/src/errors/errors';
import { Grid } from '@material-ui/core';
import FacesheetHeader from 'shared-assets/facesheet-ui/components/Facesheet/Header/FacesheetHeader';
import { getPatientById } from 'shared-assets/facesheet-ui/service/patient/service';
import ErrorPage from 'shared-assets/facesheet-ui/components/Facesheet/Error/ErrorPage';
import { CACHED_DATA_STATUS_CODE, CONFIGURATION_ERROR, DATE_CACHED_HTTP_HEADER, INVALID_ENTRY_ERROR, } from 'shared-assets/facesheet-ui/service/facesheet/types';
import CardLayout from 'shared-assets/facesheet-ui/components/Facesheet/Card/CardLayout';
import FacesheetCustomizationModal from 'shared-assets/facesheet-ui/components/FacesheetCustomization/FacesheetCustomizationModal';
import { getFacesheetConfiguration, updateFacesheetConfiguration, getAhrqFlag, getPatientStatus, } from 'shared-assets/facesheet-ui/service/facesheet/service';
import AlertButton from 'shared-assets/facesheet-ui/components/Facesheet/Error/AlertButton';
import { ErrorBoundary } from 'react-error-boundary';
import FacesheetNavBar from 'shared-assets/facesheet-ui/components/ChartNavBar/FacesheetNavBar';
import { getNavBarErrorLinks } from 'shared-assets/facesheet-ui/utils/navBarHelper';
import GeneralError from 'shared-assets/facesheet-ui/components/Facesheet/Error/GeneralError';
import { getCachedDataContext, refreshPage, } from 'shared-assets/facesheet-ui/utils/patientHelper';
import practice from 'shared-assets/lib/sdk/practice';
export var PatientContext = React.createContext(null);
export var PatientHistoryFTContext = React.createContext(true);
export var PatientStatusContext = React.createContext(undefined);
export var PatientVitalsFTContext = React.createContext(true);
export var PatientHeaderCachedContext = React.createContext(undefined);
export var TimezoneContext = createContext('');
var Facesheet = function (_a) {
    var patientId = _a.patientId;
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(false), inError = _c[0], setInError = _c[1];
    var _d = useState(true), ahrqFlagState = _d[0], setAhrqFlagState = _d[1];
    var _e = useState(null), patient = _e[0], setPatient = _e[1];
    var _f = useState(null), facesheetConfiguration = _f[0], setFacesheetConfiguration = _f[1];
    var _g = useState([]), linksState = _g[0], setLinksState = _g[1];
    var _h = useState(''), linksKeyState = _h[0], setLinksKeyState = _h[1];
    var _j = useState([]), widgetsState = _j[0], setWidgetsState = _j[1];
    var _k = useState(false), openFacesheetCustomizationModal = _k[0], setOpenFacesheetCustomizationModal = _k[1];
    var _l = useState(false), configError = _l[0], setConfigError = _l[1];
    var _m = useState(undefined), patientStatus = _m[0], setPatientStatus = _m[1];
    var _o = useState(false), isPatientHeaderCachedData = _o[0], setIsPatientHeaderCachedData = _o[1];
    var _p = useState(''), patientHeaderCachedDate = _p[0], setPatientHeaderCachedDate = _p[1];
    var _q = useState('utc'), timeZone = _q[0], setTimeZone = _q[1];
    var setFacesheetConfigurationState = function (configurationResponse) {
        setLinksState(configurationResponse.links);
        var selectedLinks = configurationResponse.links
            .filter(function (link) { return link.enabled; })
            .map(function (link) { return link.linkName; });
        setLinksKeyState(selectedLinks.join('-'));
        setWidgetsState(configurationResponse.widgets);
        setFacesheetConfiguration(configurationResponse);
    };
    var fetchFacesheetConfiguration = function () { return __awaiter(void 0, void 0, void 0, function () {
        var configurationResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getFacesheetConfiguration()];
                case 1:
                    configurationResponse = _a.sent();
                    setFacesheetConfigurationState(configurationResponse);
                    return [2 /*return*/];
            }
        });
    }); };
    var submitFacesheetConfiguration = function (updatedLinksState, updatedWidgetsState) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (facesheetConfiguration) {
                facesheetConfiguration.links = updatedLinksState;
                facesheetConfiguration.widgets = updatedWidgetsState;
                updateFacesheetConfiguration(facesheetConfiguration).then(function (configurationResponse) {
                    setFacesheetConfigurationState(configurationResponse);
                });
            }
            return [2 /*return*/];
        });
    }); };
    var fetchPatient = function () { return __awaiter(void 0, void 0, void 0, function () {
        var patientResponse, body, cachedDate, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    return [4 /*yield*/, getPatientById(patientId)];
                case 1:
                    patientResponse = _a.sent();
                    if (!(patientResponse === null || patientResponse === void 0 ? void 0 : patientResponse.ok)) return [3 /*break*/, 3];
                    return [4 /*yield*/, patientResponse.json()];
                case 2:
                    body = _a.sent();
                    setPatient(body);
                    if ((patientResponse === null || patientResponse === void 0 ? void 0 : patientResponse.status) === CACHED_DATA_STATUS_CODE) {
                        setIsPatientHeaderCachedData(true);
                        cachedDate = patientResponse.headers.get(DATE_CACHED_HTTP_HEADER);
                        if (cachedDate) {
                            setPatientHeaderCachedDate(cachedDate);
                        }
                    }
                    _a.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    rollbar.error(error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var toggleFacesheetCustomizationModal = function () {
        setOpenFacesheetCustomizationModal(!openFacesheetCustomizationModal);
    };
    var action = React.createElement(AlertButton, null);
    var navBarErrorFallback = function () {
        var navBarLinks = getNavBarErrorLinks();
        return React.createElement(FacesheetNavBar, { links: navBarLinks, patientId: patientId });
    };
    var errorFallback = function () {
        return React.createElement(GeneralError, { reloadData: refreshPage });
    };
    var fetchAhrqFlagState = function () { return __awaiter(void 0, void 0, void 0, function () {
        var ahrqFlag;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getAhrqFlag()];
                case 1:
                    ahrqFlag = _a.sent();
                    setAhrqFlagState(ahrqFlag);
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchPatientStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
        var patientStatus;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getPatientStatus(patientId)];
                case 1:
                    patientStatus = _a.sent();
                    setPatientStatus(patientStatus);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (patientId > 0) {
            fetchPatient()
                .catch(function (error) {
                var _a, _b;
                if (((_a = error === null || error === void 0 ? void 0 : error.body) === null || _a === void 0 ? void 0 : _a.status) === 403 || ((_b = error === null || error === void 0 ? void 0 : error.body) === null || _b === void 0 ? void 0 : _b.status) === 404) {
                    setInError(true);
                }
                rollbar.error(error);
            })
                .finally(function () {
                setLoading(false);
            });
            fetchPatientStatus().catch(function (error) {
                rollbar.error(error);
            });
            fetchAhrqFlagState().catch(function (error) {
                rollbar.error(error);
            });
            if (!facesheetConfiguration) {
                fetchFacesheetConfiguration().catch(function (error) {
                    setConfigError(true);
                    rollbar.error(error);
                });
            }
            practice
                .getTimeZone()
                .then(function (zone) {
                setTimeZone(zone === null || zone === void 0 ? void 0 : zone.timeZoneId);
            })
                .catch(function (error) { return rollbar.error(error); });
        }
    }, [patientId]);
    return (React.createElement(Loader, { condition: !loading }, !loading &&
        (inError ? (React.createElement(ErrorPage, { title: INVALID_ENTRY_ERROR.title, message: INVALID_ENTRY_ERROR.message })) : (React.createElement(PatientContext.Provider, { value: patient },
            React.createElement(TimezoneContext.Provider, { value: timeZone },
                React.createElement(PatientHeaderCachedContext.Provider, { value: patientHeaderCachedDate
                        ? getCachedDataContext(patientHeaderCachedDate)
                        : undefined },
                    React.createElement(FacesheetHeader, { patientId: patientId, reloadPatient: fetchPatient, patientStatus: patientStatus })),
                React.createElement(Grid, { container: true },
                    React.createElement(Grid, { item: true, xs: 1 },
                        React.createElement(ErrorBoundary, { FallbackComponent: navBarErrorFallback, onError: function (error) { return rollbar.error(error); } },
                            React.createElement(ChartNavBar, { key: linksKeyState, patientId: patientId, isModernFacesheetDisplayed: true }))),
                    React.createElement(Grid, { container: true, item: true, xs: 11 },
                        React.createElement(Grid, { item: true, xs: 1 }),
                        React.createElement(Grid, { item: true, xs: 10 },
                            React.createElement(Grid, { container: true, justify: "space-between" },
                                React.createElement(Grid, { item: true, style: { alignSelf: 'center' } },
                                    React.createElement(Typography, { variant: "h1", component: "div" }, "Facesheet")),
                                React.createElement(Grid, { item: true },
                                    React.createElement(ErrorBoundary, { FallbackComponent: errorFallback, onError: function (error) { return rollbar.error(error); } },
                                        !configError && (React.createElement(Box, { mt: 1, mb: 1 },
                                            React.createElement(Button, { variant: "text", color: "vitality", onClick: toggleFacesheetCustomizationModal },
                                                React.createElement(Typography, { component: "div" }, "Customize View")))),
                                        openFacesheetCustomizationModal && (React.createElement(FacesheetCustomizationModal, { links: linksState, widgets: widgetsState, toggleModal: toggleFacesheetCustomizationModal, submitConfiguration: submitFacesheetConfiguration }))))),
                            configError && (React.createElement(Box, { mb: 2 },
                                React.createElement(Alert, { severity: "warning", action: action }, CONFIGURATION_ERROR))),
                            React.createElement(PatientHistoryFTContext.Provider, { value: true },
                                React.createElement(PatientStatusContext.Provider, { value: patientStatus },
                                    React.createElement(PatientVitalsFTContext.Provider, { value: true },
                                        React.createElement(CardLayout, { patientId: patientId, widgetsState: widgetsState, ahrqFlag: ahrqFlagState, patientStatus: patientStatus }))))),
                        React.createElement(Grid, { item: true, xs: 1 })))))))));
};
export default Facesheet;
